import axios from 'axios';

export default function getConfig() {
  const url = `${window.location.protocol}//${window.location.host}/config/config.json`;
  return {
    type: 'CONFIG_FETCH',
    payload: axios.get(url)
  };
}



// WEBPACK FOOTER //
// ./src/actions/getConfig.js